/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GamePbpModelDto } from '../../models/game-pbp-model-dto';

export interface GameTrackerControllerCreateGame$Params {
      body: GamePbpModelDto
}

export function gameTrackerControllerCreateGame(http: HttpClient, rootUrl: string, params: GameTrackerControllerCreateGame$Params, context?: HttpContext): Observable<StrictHttpResponse<GamePbpModelDto>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerControllerCreateGame.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GamePbpModelDto>;
    })
  );
}

gameTrackerControllerCreateGame.PATH = '/game-tracker/games';
